export const onGetInitialPages = (chosenPage: number, maxPages: number, pages: number[]): number[] => {
    if (chosenPage < maxPages - 1) {
        return pages.slice(pages[0], maxPages)
    }
    return [0]
}
